module.exports = __webpack_public_path__ + "static/github-integration-54b92f261e617f951dc46422b9803ba3.png";